import React, { Component } from 'react'
import {Typeahead} from 'react-bootstrap-typeahead' // ES2015
import styled from 'styled-components'
import { graphql} from 'react-apollo'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'
import NotifyToReview from '../queries/NotifyToReview'
import 'react-bootstrap-typeahead/css/Typeahead.css'

const Container = styled(FadeInUpWrapper)`
  min-height: 354px;
  width: 543px;
  border-radius: 0 0 4px 4px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px 0 #DBDBDC;
`
const Header = styled.div`
  height: 49px;
  width: 543px;
  background-color: #DFDFDF;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`
const Title = styled.div`
  height: 19px;
  min-width: 300px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  grid-column-start: 2;
  grid-column-end: 2;
  align-self: center;
  justify-self: center;
`
const Close = styled.span`
  height: 12px;
  width: 12px;
  grid-column-start: 3;
  grid-column-end: 3;
  cursor: pointer;
  justify-self: end;
  align-self: center;
  margin-right: 15px;
  margin-bottom: 10px;
`
const Form = styled.section`
  padding: 15px;
`
const InputContainer = styled.div`
  padding: 10px 0;
`
const ButtonContainer = styled.div`
  padding: 10px 0;
  float: right;
`
const TextArea = styled.textarea`
  font-size: 11pt;
  resize: vertical;
  height: 112px;
  width: 500px;
  border: 1px solid #DBDBDC;
  background-color: #FFFFFF;
`
const Label = styled.label`
  font-size: 11pt;
`
const TypeaheadContainer = styled.div`
  min-height: 47px;
  width: 513px;
  border: 1px solid #DBDBDC;
  background-color: #FFFFFF;
`
const NotifyButton = styled.button`
  height: 34px;
  width: 84px;
  border-radius: 4px;
  background-color: #3399CC;
  color: #FFFFFF;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0.36px;
  line-height: 19px;
  text-align: center;
  cursor: pointer;
  &:disabled {
    background-color: #DBDBDC;
    color: #FFFFFF;
    cursor: default;
  }
`
const CancelButton = styled.button`
    height: 19px;
    width: 44px;
    color: #6A6A6A;
    font-family: "Open Sans";
    font-size: 14px;
    line-height: 19px;
    border: none;
    margin-right: 20px;
  }
`
const Icon = styled.i`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: black;
  padding: 5px;
  margin-left: 1px;
  cursor: pointer;
`

class NotifyBankToReviewModal extends Component {
  constructor(props) {
    super(props)
    const isFollowersExist = props.followers.length > 0
    this.state = {
      isButtonDisabled: !isFollowersExist,
      content: '',
      recipientIds: isFollowersExist ? props.followers.map(({ rid }) => rid ) : [],
    }
  }

  onTypeaheadSearch = selected => {
    const { adminsWithPermission } = this.props
    const isButtonDisabled = selected.length <= 0
    let recipientIds = []
    selected.map(selectedAdmin => {
      return adminsWithPermission.filter(({ name, rid }) => {
        if (name === selectedAdmin){
          return recipientIds.push(rid)
        }
      })
    })
    this.setState({
      recipientIds,
      isButtonDisabled,
    })
  }

  onNotifyToReviewClick = async () => {
    const { toggleModal, notifyToReview, loanId, successReponse } = this.props
    const { content, recipientIds } = this.state
    try {
      await notifyToReview({
        variables: {
          input: {
            loanId,
            content,
            recipientIds
          }
        }
      })
    } catch (err) {
      console.error(err)
    }
    toggleModal()
    successReponse()
  }

  onContentChange = (event) => {
    this.setState({
      content: event.target.value,
    })
  }

  render() {
    const { toggleModal, adminsWithPermission, isBankUser, followers } = this.props
    const { isButtonDisabled } = this.state
    const title = `Notify ${isBankUser ? "SmartBiz" : "Bank"} to Review Highlights`
    const optionalText =  `Add an optional message to the ${isBankUser ? "SmartBiz" : "Bank"}`
    return (
      <Container>
        <Header>
          <Title>
            {title}
          </Title>
          <Close onClick={toggleModal}>
            <Icon className="fa fa-times" />
          </Close>
        </Header>
        <Form>
        <InputContainer>
            <TextArea
              disabled={false}
              placeholder={optionalText}
              ref={(content) => this.content = content}
              onChange={this.onContentChange}
            />
          </InputContainer>
          <InputContainer>
            <Label>
              This will notify the people below who are following this loan application.
            </Label>
            <TypeaheadContainer>
              <Typeahead
                id="rm_typeahead"
                labelKey="name"
                multiple
                defaultSelected={followers.map(({ name }) => name)}
                ref={(typeahead) => this.typeahead = typeahead}
                options={adminsWithPermission.map(({ name }) => name)}
                onChange={this.onTypeaheadSearch}
                placeholder="Choose User to Notify..."
              />
            </TypeaheadContainer>
          </InputContainer>
          <ButtonContainer>
            <CancelButton onClick={toggleModal}>
              Cancel
            </CancelButton>
            <NotifyButton
              disabled={isButtonDisabled}
              onClick={this.onNotifyToReviewClick}>
              Notify
            </NotifyButton>
          </ButtonContainer>
        </Form>
      </Container>
    )
  }
}
export { NotifyBankToReviewModal }

export default graphql(NotifyToReview, {
  name: 'notifyToReview'
})(NotifyBankToReviewModal)
